document.addEventListener("DOMContentLoaded", () => {
  initHeaderHamburger();
  initPrecioMiles();
  initFAQ();
  confirmarEliminacionPropiedad();
  initFiltroProductos();
  initMenuHamburguesa();
  inicializarAcordeonClientes();
  inicializarProductosPanelAdmin();
  inicializarProductosDinamicos();
  if (document.getElementById('cliente_buscar')) inicializarClienteAutocomplete('cliente_buscar');
  if (document.getElementById('cliente_buscar_panel')) inicializarClienteAutocomplete('cliente_buscar_panel');
});

/* ----------------- ACORDEÓN CLIENTES ----------------- */
function inicializarAcordeonClientes() {
  const items = document.querySelectorAll(".informacion_de_datos_clientes");

  items.forEach((item) => {
    item.addEventListener("click", () => {
      const detalle = item.nextElementSibling;
      if (!detalle) return;

      detalle.classList.toggle("activo");

      const masMenos = item.querySelector(".mas_o_menos_final");
      if (masMenos) {
        masMenos.textContent = detalle.classList.contains("activo") ? "-" : "+";
      }
    });
  });
}


/* ----------------- SUGERENCIAS CLIENTES ----------------- */
function inicializarClienteAutocomplete(idCampo = 'cliente_buscar') {
  const clienteInput = document.getElementById(idCampo);
  const sugerenciasBox = document.getElementById('sugerencias-clientes');
  const clienteHidden = document.getElementById('cliente_id'); // puede ser null
  let debounceTimer;

  // clienteInput y sugerenciasBox SÍ son obligatorios
  if (!clienteInput || !sugerenciasBox) return;

  const fetchJSON = (url) => fetch(url).then(r => r.json());

  clienteInput.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    const q = this.value.trim();

    if (clienteHidden) clienteHidden.value = ''; // sólo si existe

    if (q.length < 1) { 
      sugerenciasBox.innerHTML = ''; 
      return; 
    }

    debounceTimer = setTimeout(() => {
      fetchJSON(`/api/clientes?q=${encodeURIComponent(q)}`)
        .then(list => {
          if (!Array.isArray(list)) { sugerenciasBox.innerHTML = ''; return; }
          if (list.length === 0) { 
            sugerenciasBox.innerHTML = '<div class="lista"><div>No hay coincidencias</div></div>'; 
            return; 
          }

          const html = list.map(c => 
            `<div data-id="${c.id}" data-nombre="${c.nombre_cliente}" data-negocio="${c.nombre_negocio}">
              ${c.nombre_cliente} – ${c.nombre_negocio}
            </div>`
          ).join('');

          sugerenciasBox.innerHTML = '<div class="lista">'+html+'</div>';

          document.querySelectorAll('#sugerencias-clientes .lista div').forEach(el => {
            el.addEventListener('click', function(){
              if (clienteHidden) clienteHidden.value = this.dataset.id;
              clienteInput.value = `${this.dataset.nombre} – ${this.dataset.negocio}`;
              sugerenciasBox.innerHTML = '';
            });
          });
        })
        .catch(e => { 
          console.error(e); 
          sugerenciasBox.innerHTML=''; 
        });
    }, 250);
  });
}



/* ----------------- PRODUCTOS DINÁMICOS ----------------- */
    function inicializarProductosDinamicos() {
      const productosContainer = document.getElementById('productos-container');
      const agregarBtn = document.getElementById('agregar-producto');

      if(!productosContainer || !agregarBtn) {
        return;
      }

      const nuevaFila = (index) => {
        const div = document.createElement('div');
        div.className = 'producto-item';
        div.dataset.index = index;

              div.innerHTML = `
        <label>Producto</label>
        <input type="text" name="productos[${index}][producto_nombre]" 
              class="producto_buscar" autocomplete="off" required>
        <input type="hidden" name="productos[${index}][producto_id]" class="producto_id">

        <div class="sugerencias-productos"></div>

        <label>Cantidad</label>
        <input type="number" name="productos[${index}][cantidad]" class="cantidad" min="1" value="1" required>

        <input type="hidden" name="productos[${index}][precio_venta]" class="precio_venta" step="0.01" required>

        <input type="hidden" name="productos[${index}][subtotal]" class="subtotal" step="0.01" readonly>

        <button type="button" class="remove-producto">Eliminar</button>
      `;


        attachProductoAutocomplete(div); // ✅ aquí el nuevo hook
        return div;
      };

      function attachProductoAutocomplete(fila) {
        const inputBuscar = fila.querySelector('.producto_buscar');
        const inputId = fila.querySelector('.producto_id');
        const cantidad = fila.querySelector('.cantidad');
        const precioVenta = fila.querySelector('.precio_venta');
        const subtotal = fila.querySelector('.subtotal');
        const sugerencias = fila.querySelector('.sugerencias-productos');
        const removeBtn = fila.querySelector('.remove-producto');

        // Autocompletar
        inputBuscar.addEventListener('input', function() {
          const q = this.value.trim();
          if (q.length < 2) {
            sugerencias.innerHTML = '';
            sugerencias.style.display = 'none';
            return;
          }
          fetch(`/api/productos?nombre=${encodeURIComponent(q)}`)
            .then(r => r.json())
            .then(list => {
              sugerencias.innerHTML = list.map(p =>
                `<div class="sugerencia" 
                      data-id="${p.id}" 
                      data-venta="${p.valor_venta}">
                  ${p.nombre_producto}
                </div>`
              ).join('');
              sugerencias.style.display = 'block';
            })
            .catch(err => {
              console.error('Error cargando productos:', err);
              sugerencias.innerHTML = '';
            });
        });

        // Selección de sugerencia
        sugerencias.addEventListener('click', function(e) {
          if (e.target.classList.contains('sugerencia')) {
            inputBuscar.value = e.target.textContent;
            inputId.value = e.target.dataset.id;
            precioVenta.value = e.target.dataset.venta;
            sugerencias.innerHTML = '';
            sugerencias.style.display = 'none';
            calcularTotales();
          }
        });

        // Calcular totales
        const calcularTotales = () => {
          const c = Number(cantidad.value) || 0;
          const pv = Number(precioVenta.value) || 0;
          subtotal.value = (c * pv).toFixed(2);
        };

        cantidad.addEventListener('input', calcularTotales);
        precioVenta.addEventListener('input', calcularTotales);

        removeBtn.addEventListener('click', function() { 
          fila.remove(); 
          renumerarFilas(); 
        });
      }



      function renumerarFilas(){
        const filas = productosContainer.querySelectorAll('.producto-item');
        filas.forEach((fila, i) => {
          fila.dataset.index = i;
          fila.querySelectorAll('select, input').forEach(input => {
            const campoMatch = input.name.match(/\[([^\]]+)\]$/);
            if (campoMatch) {
              const campo = campoMatch[1];
              input.name = `productos[${i}][${campo}]`;
            }
          });
        });
      }

      // inicializar para la primera fila
      document.querySelectorAll('.producto-item').forEach(el => attachProductoAutocomplete(el));

      // botón agregar
      agregarBtn.addEventListener('click', function(){
        const index = productosContainer.querySelectorAll('.producto-item').length;
        const fila = nuevaFila(index);
        productosContainer.appendChild(fila);
        renumerarFilas();
      });
    }

    /* ----------------- SUGERENCIAS PRODUCTOS PANEL ADMIN ---------------- */
function inicializarProductosPanelAdmin() {
  
    const inputProducto = document.querySelector("#producto");
    const listaProductos = document.querySelector("#sugerencias-productos");

    if (inputProducto) {

        inputProducto.addEventListener("input", async function () {
            const q = this.value.trim();

            if (q.length < 2) {
                listaProductos.innerHTML = "";
                return;
            }

            const res = await fetch(`/api/productosBuscar?q=${encodeURIComponent(q)}`);
            const data = await res.json();

            listaProductos.innerHTML = "";

            data.forEach(p => {

                const texto = `${p.nombre_producto}`;

                const item = document.createElement("div");
                item.classList.add("autocomplete-item");
                item.textContent = texto;

                item.addEventListener("click", () => {
                    inputProducto.value = texto;
                    listaProductos.innerHTML = "";
                });

                listaProductos.appendChild(item);
            });
        });

        document.addEventListener("click", (e) => {
            if (!listaProductos.contains(e.target) && e.target !== inputProducto) {
                listaProductos.innerHTML = "";
            }
        });
    }
}


//------------ALERTA ANTES DE ELIMINAR------------//
function confirmarEliminacionPropiedad() {
    const formulariosEliminar = document.querySelectorAll('form[action="/eliminarFactura"], form[action="/eliminarGasto"]');

    formulariosEliminar.forEach(formulario => {
        formulario.addEventListener('submit', function(e) {
            e.preventDefault();

            swal.fire({
                title: '¿Estás seguro?',
                text: "Esta acción eliminará el registro permanentemente.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                customClass: {
                    popup: 'mi-alerta',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    formulario.submit();
                }
            });
        });
    });
}

function initFiltroProductos() {
    const tipoSelect = document.getElementById('tipo_producto');
    const marcaSelect = document.getElementById('marca_producto');

    if (!tipoSelect || !marcaSelect) return;

    tipoSelect.addEventListener('change', async () => {
        const tipo = tipoSelect.value;

        // limpiar las opciones de marcas
        marcaSelect.innerHTML = '<option value="">-- Selecciona Marca --</option>';

        if (tipo) {
            try {
                const res = await fetch(`/obtenerMarcas?tipo=${encodeURIComponent(tipo)}`);
                const marcas = await res.json();

                marcas.forEach(marca => {
                    const option = document.createElement('option');
                    option.value = marca;
                    option.textContent = marca;
                    marcaSelect.appendChild(option);
                });
            } catch (err) {
                console.error("Error cargando marcas:", err);
            }
        }
    });
}

function initMenuHamburguesa() {
    const toggle = document.querySelector(".menu-toggle");
    const nav = document.querySelector(".nav_links");

    if (toggle && nav) {
        toggle.addEventListener("click", () => {
            nav.classList.toggle("active");
            toggle.innerHTML = nav.classList.contains("active")
                ? '<i class="fas fa-times"></i>'
                : '<i class="fas fa-bars"></i>';
        });
    }
}

function initFAQ() {
  const items = document.querySelectorAll(".faq_item");

  items.forEach(item => {
    const pregunta = item.querySelector(".faq_pregunta");
    pregunta.addEventListener("click", () => {
      // Cierra otros
      items.forEach(i => {
        if (i !== item) i.classList.remove("activo");
      });
      // Alterna este
      item.classList.toggle("activo");
    });
  });
}

function initHeaderHamburger(options = {}) {
  const {
    btnMenuSel = '#btnMenu',
    btnCloseSel = '#btnCerrar',
    overlaySel = '#overlay',
    drawerSel = '#menuHamburguesa',
    lockBodyClass = 'nav-open',
    openClass = 'is-open'
  } = options;

  const btnMenu  = document.querySelector(btnMenuSel);
  const btnClose = document.querySelector(btnCloseSel);
  const overlay  = document.querySelector(overlaySel);
  const drawer   = document.querySelector(drawerSel);

  if (!btnMenu || !overlay || !drawer) {
    console.warn('[initHeaderHamburger] Faltan elementos requeridos.');
    return;
  }

  const focusableSel = 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])';
  let prevFocused = null;

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    const focusables = drawer.querySelectorAll(focusableSel);
    if (!focusables.length) return;
    const first = focusables[0];
    const last  = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  function openNav() {
    prevFocused = document.activeElement;
    drawer.classList.add(openClass);
    overlay.classList.add(openClass);
    overlay.hidden = false;

    document.body.classList.add(lockBodyClass);
    btnMenu.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');

    document.addEventListener('keydown', onKeydown);
    drawer.addEventListener('keydown', trapFocus);

    const firstLink = drawer.querySelector('.drawer_links a') || drawer.querySelector('a,button');
    if (firstLink) firstLink.focus();
  }

  function closeNav() {
    drawer.classList.remove(openClass);
    overlay.classList.remove(openClass);

    setTimeout(() => { overlay.hidden = true; }, 200);

    document.body.classList.remove(lockBodyClass);
    btnMenu.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');

    document.removeEventListener('keydown', onKeydown);
    drawer.removeEventListener('keydown', trapFocus);

    if (prevFocused && typeof prevFocused.focus === 'function') prevFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeNav();
  }

  // Listeners
  btnMenu.addEventListener('click', openNav);
  if (btnClose) btnClose.addEventListener('click', closeNav);
  overlay.addEventListener('click', closeNav);

  // 🔽 NUEVO: cerrar al pulsar cualquier enlace del menú
  const drawerLinks = drawer.querySelectorAll('.drawer_links a');
  drawerLinks.forEach(link => {
    link.addEventListener('click', () => {
      closeNav();
    });
  });

  return { openNav, closeNav };
}

  function initPrecioMiles() {
    const minEl = document.querySelector('.valor_venta');
    const maxEl = document.querySelector('.valor_gasto');
    const maxAl = document.querySelector('.actualizacion_valor_venta');
    [minEl, maxEl, maxAl].forEach(el => el && bindMilesMask(el));
  }

  
  function bindMilesMask(input) {
    const fmt = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });

    input.addEventListener('input', () => {
      const selStart = input.selectionStart ?? input.value.length;
      const raw = input.value;

      // 1) Mantén solo dígitos
      const digits = raw.replace(/\D+/g, '').replace(/^0+/, '');
      if (digits === '') {
        input.value = '';
        return;
      }

      // 2) Cuenta cuántos dígitos había a la izquierda del caret
      const leftRaw = raw.slice(0, selStart);
      const leftDigitsCount = (leftRaw.match(/\d/g) || []).length;

      // 3) Formatea con puntos de miles
      const formatted = fmt.format(Number(digits));

      // 4) Coloca el caret donde queden esos mismos dígitos
      let newCaret = 0, seen = 0;
      for (let i = 0; i < formatted.length; i++) {
        if (/\d/.test(formatted[i])) {
          seen++;
          if (seen === leftDigitsCount) { newCaret = i + 1; break; }
        }
        // si no alcanza, queda al final
        if (i === formatted.length - 1) newCaret = formatted.length;
      }

      input.value = formatted;
      // Reaplica caret (en móviles algunos navegadores lo ignoran, no pasa nada)
      try { input.setSelectionRange(newCaret, newCaret); } catch {}
    });

    // Enter aplica filtro (por si no lo tienes ya en initFiltroPrecio)
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const panel = input.closest('.precio_panel');
        panel?.querySelector('.precio_filtrar')?.click();
      }
    });

    // Limpia ceros sobrantes al perder foco (opcional)
    input.addEventListener('blur', () => {
      const digits = input.value.replace(/\D+/g, '').replace(/^0+/, '');
      input.value = digits ? new Intl.NumberFormat('es-CO').format(Number(digits)) : '';
    });
  }
